import GET_TIB_BANNERS from '../graphql/getTibBanners.graphql'
import apolloProvider from '@/services/apolloProvider.service'
import { format, endOfDay, startOfDay, addDays } from 'date-fns'
import { make } from 'vuex-pathify'

const createModel = () => ({
  uuid: '',
  title: '',
  text: '',
  reason: '',
  train: '',
  time_start: format(new Date(), 'yyyy-MM-dd HH:mm'),
  time_end: format(addDays(new Date(), 1), 'yyyy-MM-dd HH:mm')
})

const createState = () => ({
  model: createModel(),
  data: [],
  count: 0,
  selected: null,
  filter: {
    date: format(new Date(), 'yyyy-MM-dd')
  }
})

const state = createState()

const mutations = make.mutations(state)

const getters = {}

const actions = {
  removeSelected({ state, commit }) {
    if (state.selected) {
      commit('removeSelected', state.selected)
    }
  },

  async fetchInital({ commit }, date) {
    const { data } = await apolloProvider.clients.defaultClient.query({
      query: GET_TIB_BANNERS,
      fetchPolicy: 'no-cache',
      variables: {
        filter: {
          from: startOfDay(new Date(date)),
          to: endOfDay(new Date(date))
        }
      }
    })
    const today = new Date()
    const count = data.tib_banner.filter(x => {
      return (
        +new Date(x.time_start) <= +today && +today <= +new Date(x.time_end)
      )
    }).length
    commit('SET_COUNT', count)
  },

  async fetch({ commit, dispatch }, date) {
    const { data } = await apolloProvider.clients.defaultClient.query({
      query: GET_TIB_BANNERS,
      fetchPolicy: 'no-cache',
      variables: {
        filter: {
          from: startOfDay(new Date(date)),
          to: endOfDay(new Date(date))
        }
      }
    })

    commit('SET_DATA', data.tib_banner || [])

    dispatch('fetchInital', format(new Date(), 'yyyy-MM-dd'))

    return data.tib_banner || []
  },

  resetModel({ commit }) {
    commit('RESET_MODEL')
  },

  editModel({ commit, state }, data) {
    commit('SET_MODEL', {
      ...state.model,
      uuid: data.uuid,
      title: data.title,
      text: data.text,
      reason: data.reason,
      train: data.train,
      time_start: format(new Date(data.time_start), 'yyyy-MM-dd HH:mm'),
      time_end: format(new Date(data.time_end), 'yyyy-MM-dd HH:mm')
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations: {
    ...mutations,

    removeSelected(state, uuid) {
      state.data = state.data.filter(x => x.uuid !== uuid)
    },

    RESET_MODEL(state) {
      state.model = createModel()
    }
  },
  getters: {
    ...getters
  },
  actions
}
